import { render, staticRenderFns } from "./moduleInfo.vue?vue&type=template&id=79035937"
import script from "./moduleInfo.vue?vue&type=script&lang=js"
export * from "./moduleInfo.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports